var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orderInfo"},[_c('text-title',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"item"},_vm._l((_vm.orderInfo),function(item,key){return _c('LjbItem',{key:key,attrs:{"item":item}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-42afc04a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/list/listOrderInfo.vue
// module id = null
// module chunks = 